import { render, staticRenderFns } from "./jingboexpo.vue?vue&type=template&id=ab958b5e&scoped=true"
import script from "./jingboexpo.vue?vue&type=script&lang=js"
export * from "./jingboexpo.vue?vue&type=script&lang=js"
import style0 from "./jingboexpo.vue?vue&type=style&index=0&id=ab958b5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab958b5e",
  null
  
)

export default component.exports